import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'icon-document',
  templateUrl: './icon-document.component.html',
  styleUrls: ['./icon-document.component.scss'],
})
export class IconDocumentComponent  implements OnInit {
  @Input() size :number = 20;
  constructor() { }

  ngOnInit() {}

}
